import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isGetEmailIpWarmingAppGroupIdShowIpWarmingWidgetResult = objectOf({
  should_show_widget: boolean,
});
